function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgWgr = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M19.42 8.54c.117.199.101.408-.015.612-.174.277-.335.56-.5.84l-1.366 2.33c-.91 1.546-1.82 3.092-2.733 4.637a.555.555 0 01-.533.29.573.573 0 01-.502-.323c-.112-.199-.228-.395-.345-.593l-1.15-1.958c-.085-.148-.173-.293-.271-.457-.097.163-.187.308-.273.457l-1.15 1.957a28.08 28.08 0 00-.345.594.572.572 0 01-.502.323.56.56 0 01-.533-.29c-.433-.728-.86-1.457-1.29-2.188-.483-.815-.964-1.631-1.443-2.449l-1.365-2.33c-.165-.28-.329-.563-.5-.84-.124-.204-.142-.413-.026-.612.114-.195.298-.29.534-.29 1.476.005 2.953.015 4.429.002.373-.002.595.14.77.451.372.665.769 1.314 1.152 1.972.16.277.319.557.482.834.012.02.033.037.052.054a.203.203 0 00.051-.053c.161-.277.319-.558.482-.835.386-.658.78-1.31 1.153-1.972.173-.31.396-.453.769-.45 1.476.012 2.952.002 4.43-.003.24 0 .424.095.538.29zm-8.133 4.317c.031-.051.029-.143.003-.196-.075-.153-.174-.298-.262-.449-.528-.901-1.057-1.8-1.582-2.704-.054-.092-.117-.125-.225-.125-.984.006-1.97.006-2.953.008-.047 0-.093.007-.16.012l3.597 6.14c.104-.172.191-.31.275-.453.439-.742.875-1.487 1.307-2.233zm3.008 2.686c1.204-2.055 2.396-4.09 3.6-6.14-.07-.005-.114-.012-.16-.012-.985-.002-1.97-.002-2.953-.008-.109 0-.171.033-.225.125l-1.583 2.704c-.088.148-.184.293-.262.449a.234.234 0 000 .196c.435.745.87 1.49 1.309 2.233.082.143.17.283.274.453z",
    fill: "white"
  }));
});
SvgWgr.displayName = "SvgWgr";
SvgWgr.defaultProps = {
  size: 24,
  color: "#B80000"
};
export default SvgWgr;